export function setCookie(name, value, expirationMinutes) {
    const date = new Date();
    date.setTime(date.getTime() + (expirationMinutes * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

export function getCookie(name) {
    let searchName = name + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(searchName) == 0) {
            return cookie.substring(searchName.length, cookie.length);
        }
    }
    return "";
}